import { Injectable } from '@angular/core';
import { HttpClient, } from '@angular/common/http';
import {  Observable, } from 'rxjs';
import { DataStateChangeEventArgs, } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
import { DatePipe } from '@angular/common';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { gettimesheet } from '../timesheet.model';
import { map } from 'rxjs/operators';
import { GeneralService } from 'src/app/service/general.service';
@Injectable({
    providedIn: 'root'
})
export class TimesheetViewService extends Subject<DataStateChangeEventArgs>{
    childdata: any = [];
    timelst: any = [];
    constructor(private http: HttpClient, public global: GlobalComponent, private ngxService: NgxUiLoaderService, public general: GeneralService, public datePipe: DatePipe) {
        super();
    }
    public executeViewList(state: gettimesheet): void {
        this.getTimesheetViewList(state).subscribe(x => super.next(x));
    }
    getTimesheetViewList(state?: gettimesheet): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>("api/CFSSTimeSheet/FilterTimeSheetItem", state)
            .pipe(map(
                (response: any) =>
                (<any>{
                    result: response['result'],
                    count: response['count'],
                    totalHours: response['totalHours']
                })))
            .pipe(map((e: any) => {
                this.timelst = e.result;
                e.result = this.setdata(e);
                return e;
            })
            )
    }
    setdata(data) {
        let parentArray = [];
        let childArray = [];
        if (data?.result?.length != 0) {
            data?.result?.forEach(ParentElement => {
                if (ParentElement.timesheets.length != 0) {
                    let statuslength = ParentElement.timesheets.filter(t => t.timesheetStatus?.toUpperCase() == 'EXPORTED');
                    let status = statuslength.length > 0 ? 'EXPORTED' : "";
                    let ParentObject =
                    {
                        'clientName': ParentElement.timesheets[0].client,
                        'fromDate': this.datePipe.transform(ParentElement.timesheets.reduce(function (res, obj) {
                            return (new Date(obj.timesheetDate).getTime() < new Date(res.timesheetDate).getTime()) ? obj : res;
                        }).timesheetDate, "MM/dd/yyyy"),
                        'toDate': this.datePipe.transform(ParentElement.timesheets.reduce(function (res, obj) {
                            return (new Date(obj.timesheetDate).getTime() > new Date(res.timesheetDate).getTime()) ? obj : res;
                        }).timesheetDate, "MM/dd/yyyy"),
                        'isCliSignature': ParentElement.timesheets[0].isCliSignature == true ? 'YES' : 'NO',
                        'isEmpSignature': ParentElement.timesheets[0].isEmpSignature == true ? 'YES' : 'NO',
                        'housingCaseNote': ParentElement.timesheets[0].housingCaseNote == true ? 'YES' : 'NO',
                        'employmentService': ParentElement.timesheets[0].employmentService == true ? 'YES' : 'NO',
                        'eTimesheet': ParentElement.timesheets[0].etimesheet == true ? 'YES' : 'NO',
                        'EmployeeName': ParentElement.timesheets[0].employee,
                        'timesheetStatusLid': status,
                        'serialNo': ParentElement.serialNumber,
                        'uniqueSerialNumber': ParentElement.uniqueSerialNumber,
                        'combinedSerialNumber': ParentElement.combinedSerialNumber,
                        'totalhrs': ParentElement.totalhrs,
                        'paidpayrolls': ParentElement.paidpayrolls == true ? 'YES' : 'NO',
                        'authorizationId': ParentElement.timesheets[0]?.authorizationId,
                        'masterCode': ParentElement.timesheets[0]?.masterCode,
                    }
                    parentArray.push(ParentObject);
                    ParentElement.timesheets.forEach(ChildElement => {
                        let childObject =
                        {
                            'timesheetDate': this.datePipe.transform(ChildElement.timesheetDate, "MM/dd/yyyy"),
                            'masterCode': ChildElement.masterCode,
                            "payer": ChildElement.payer,
                            'totalHours': ChildElement.totalHours,
                            'notes': ChildElement.timesheetNotes,
                            'timeSheetId': ChildElement.id,
                            'timesheetStatusLid': ChildElement.timesheetStatus != null ? ChildElement.timesheetStatus : "",
                            'serialNo': ChildElement.serialNumber,
                            'housingCaseNote': ChildElement.housingCaseNote,
                            'employmentService': ChildElement.employmentService,
                            'uniqueSerialNumber': ChildElement.uniqueSerialNumber,
                            'combinedSerialNumber': ChildElement.combinedSerialNumber,
                            'etimesheet': ChildElement.etimesheet,
                            'authorizationId': ChildElement.authorizationId,
                            'masterServiceId': ChildElement.masterServiceId,
                            'paidpayroll': ChildElement.paidpayroll == true ? 'YES' : 'NO',
                        }
                        childArray.push(childObject);
                    });
                    this.childdata = childArray;
                }
                else {
                    parentArray = [];
                    this.childdata = [];
                }
            });
        }
        else {
            parentArray = []
        }
        return parentArray;
    }
    getchilddata() {
        return this.childdata;
    }
}
